export const PLAID_STATUS = {
  NotStarted: 'not_started',
  LoadingLinkToken: 'loading_link_token',
  ReadyToConnect: 'ready_to_connect',
  Connecting: 'connecting',
  VerifyingAccount: 'verifying_account',
  Connected: 'connected',
  Error: 'error',
};

export default {
  PLAID_STATUS,
};
